import axios from './axios'

export function getUserList() {
  return axios({
    method: "get",
    url: '/api/v1/users/'
  })
}

export function createUser(sub) {
  return axios({
    method: "post",
    url: '/api/v1/users/',
    data: sub
  })
}

export function updateUser(id,sub) {
  return axios({
    method: "put",
    url: '/api/v1/users/' + id + '/',
    data: sub
  })
}

export function deleteUser(id) {
  return axios({
    method: "delete",
    url: '/api/v1/users/' + id + '/'
  })
}